import React from 'react'
import QRisultato from '../../libQuestionario/pages/QRisultato'
import { API_SERVICES } from '..'

const PDTARisultato = () => {
  return <QRisultato
    homeRoute={API_SERVICES.PDTA.HOME_ROUTE}
    root={API_SERVICES.PDTA.ROOT} />
}

export default PDTARisultato